module.exports = __webpack_public_path__ + "img/bz.756b19ec.png";